import { MapUtils } from '../../../../utility/map-utils.js';
import { cloneData, isSameData } from '../../../dto/data-model-utils.js';
import {
  SerializedData, SerializationContext, DataModelBuilder,
  DataModel,
} from '../../../dto/data-model.js';
import { GenericOrder } from '../../orders/generic-order.js';
import { AuditLogEntryType } from '../audit-log-entry-type.js';
import { AuditLogEntry } from '../audit-log-entry.js';

export class GenericOrderAbortedEntry extends AuditLogEntry {
  static readonly TYPE_ID: string = '088e671fadc846a69c1a7d6a7dd3a857';

  private constructor(
    public readonly before: GenericOrder,
    public readonly after: GenericOrder,
  ) {
    super();
  }

  get $typeId(): string {
    return GenericOrderAbortedEntry.TYPE_ID;
  }

  get type(): AuditLogEntryType {
    return AuditLogEntryType.GenericOrderAborted;
  }

  generateQueryData(): SerializedData {
    return {
      businessRef: this.after.businessRef.encode(),
      orderId: this.after.uniqueId,
      customerId: this.after.creatorId,
      isGuestOrder: this.after.isGuestOrder,
    };
  }

  static create(args: {
    before: GenericOrder,
    after: GenericOrder,
  }): GenericOrderAbortedEntry {
    return new GenericOrderAbortedEntry(
        args.before,
        args.after,
    );
  }

  static fromMap(context: SerializationContext, map: SerializedData): GenericOrderAbortedEntry {
    return this.create({
      before: context.fromData<GenericOrder>(MapUtils.getRecord(map, 'before')),
      after: context.fromData<GenericOrder>(MapUtils.getRecord(map, 'after')),
    });
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      before: context.toData(this.before),
      after: context.toData(this.after),
    };
  }

  clone(): this {
    return GenericOrderAbortedEntry.create({
      before: cloneData(this.before),
      after: cloneData(this.after),
    }) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return isSameData(other.before, this.before) &&
           isSameData(other.after, this.after);
  }

  static verifyType(dm: DataModel): boolean {
    return dm instanceof GenericOrderAbortedEntry;
  }

  static assertType(dm: DataModel): dm is GenericOrderAbortedEntry {
    return dm instanceof GenericOrderAbortedEntry;
  }
}

export class GenericOrderAbortedEntryBuilder extends DataModelBuilder<GenericOrderAbortedEntry> {
  build(context: SerializationContext, map: SerializedData): GenericOrderAbortedEntry {
    return GenericOrderAbortedEntry.fromMap(context, map);
  }
}
